import { render } from "./EnviarMasivoEvento.vue?vue&type=template&id=1e05228e&scoped=true"
import script from "./EnviarMasivoEvento.vue?vue&type=script&lang=js"
export * from "./EnviarMasivoEvento.vue?vue&type=script&lang=js"

import "./EnviarMasivoEvento.vue?vue&type=style&index=0&id=1e05228e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e05228e"]])

export default __exports__